import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=301dea84"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=301dea84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports